import { Skeleton } from '@/components/ui/skeleton'

export const AppSourceFallback = ({ hideBranch }: { hideBranch?: boolean }) => {
  return (
    <div className="flex items-center gap-1.5">
      <Skeleton className="size-4.5 rounded-full" />
      <Skeleton className="h-5 w-48" />
      {!hideBranch ? (
        <>
          <Skeleton className="size-4.5 rounded-full" />
          <Skeleton className="h-5 w-14" />
        </>
      ) : null}
    </div>
  )
}
